/**
 * cityLookup.js — City → { state, country } mapping
 * Covers all major Indian cities + top international cities
 * Keys are lowercase for case-insensitive matching
 */
export const CITY_LOOKUP = {
  // ── Maharashtra ──
  'mumbai':        { state: 'Maharashtra',       country: 'India' },
  'pune':          { state: 'Maharashtra',       country: 'India' },
  'nagpur':        { state: 'Maharashtra',       country: 'India' },
  'nashik':        { state: 'Maharashtra',       country: 'India' },
  'aurangabad':    { state: 'Maharashtra',       country: 'India' },
  'thane':         { state: 'Maharashtra',       country: 'India' },
  'solapur':       { state: 'Maharashtra',       country: 'India' },
  'kolhapur':      { state: 'Maharashtra',       country: 'India' },
  'navi mumbai':   { state: 'Maharashtra',       country: 'India' },

  // ── Delhi / NCR ──
  'delhi':         { state: 'Delhi',             country: 'India' },
  'new delhi':     { state: 'Delhi',             country: 'India' },
  'noida':         { state: 'Uttar Pradesh',     country: 'India' },
  'gurgaon':       { state: 'Haryana',           country: 'India' },
  'gurugram':      { state: 'Haryana',           country: 'India' },
  'faridabad':     { state: 'Haryana',           country: 'India' },
  'ghaziabad':     { state: 'Uttar Pradesh',     country: 'India' },

  // ── Karnataka ──
  'bengaluru':     { state: 'Karnataka',         country: 'India' },
  'bangalore':     { state: 'Karnataka',         country: 'India' },
  'mysuru':        { state: 'Karnataka',         country: 'India' },
  'mysore':        { state: 'Karnataka',         country: 'India' },
  'hubli':         { state: 'Karnataka',         country: 'India' },
  'mangalore':     { state: 'Karnataka',         country: 'India' },
  'belgaum':       { state: 'Karnataka',         country: 'India' },

  // ── Tamil Nadu ──
  'chennai':       { state: 'Tamil Nadu',        country: 'India' },
  'coimbatore':    { state: 'Tamil Nadu',        country: 'India' },
  'madurai':       { state: 'Tamil Nadu',        country: 'India' },
  'tiruchirappalli':{ state: 'Tamil Nadu',       country: 'India' },
  'trichy':        { state: 'Tamil Nadu',        country: 'India' },
  'salem':         { state: 'Tamil Nadu',        country: 'India' },
  'tirunelveli':   { state: 'Tamil Nadu',        country: 'India' },

  // ── Telangana ──
  'hyderabad':     { state: 'Telangana',         country: 'India' },
  'warangal':      { state: 'Telangana',         country: 'India' },
  'nizamabad':     { state: 'Telangana',         country: 'India' },
  'secunderabad':  { state: 'Telangana',         country: 'India' },

  // ── Andhra Pradesh ──
  'visakhapatnam': { state: 'Andhra Pradesh',    country: 'India' },
  'vizag':         { state: 'Andhra Pradesh',    country: 'India' },
  'vijayawada':    { state: 'Andhra Pradesh',    country: 'India' },
  'guntur':        { state: 'Andhra Pradesh',    country: 'India' },
  'tirupati':      { state: 'Andhra Pradesh',    country: 'India' },

  // ── Gujarat ──
  'ahmedabad':     { state: 'Gujarat',           country: 'India' },
  'surat':         { state: 'Gujarat',           country: 'India' },
  'vadodara':      { state: 'Gujarat',           country: 'India' },
  'rajkot':        { state: 'Gujarat',           country: 'India' },
  'gandhinagar':   { state: 'Gujarat',           country: 'India' },
  'bhavnagar':     { state: 'Gujarat',           country: 'India' },

  // ── Rajasthan ──
  'jaipur':        { state: 'Rajasthan',         country: 'India' },
  'jodhpur':       { state: 'Rajasthan',         country: 'India' },
  'udaipur':       { state: 'Rajasthan',         country: 'India' },
  'kota':          { state: 'Rajasthan',         country: 'India' },
  'ajmer':         { state: 'Rajasthan',         country: 'India' },
  'bikaner':       { state: 'Rajasthan',         country: 'India' },

  // ── West Bengal ──
  'kolkata':       { state: 'West Bengal',       country: 'India' },
  'calcutta':      { state: 'West Bengal',       country: 'India' },
  'durgapur':      { state: 'West Bengal',       country: 'India' },
  'howrah':        { state: 'West Bengal',       country: 'India' },
  'asansol':       { state: 'West Bengal',       country: 'India' },
  'siliguri':      { state: 'West Bengal',       country: 'India' },

  // ── Uttar Pradesh ──
  'lucknow':       { state: 'Uttar Pradesh',     country: 'India' },
  'kanpur':        { state: 'Uttar Pradesh',     country: 'India' },
  'agra':          { state: 'Uttar Pradesh',     country: 'India' },
  'varanasi':      { state: 'Uttar Pradesh',     country: 'India' },
  'allahabad':     { state: 'Uttar Pradesh',     country: 'India' },
  'prayagraj':     { state: 'Uttar Pradesh',     country: 'India' },
  'meerut':        { state: 'Uttar Pradesh',     country: 'India' },
  'bareilly':      { state: 'Uttar Pradesh',     country: 'India' },
  'aligarh':       { state: 'Uttar Pradesh',     country: 'India' },

  // ── Punjab ──
  'chandigarh':    { state: 'Chandigarh',        country: 'India' },
  'ludhiana':      { state: 'Punjab',            country: 'India' },
  'amritsar':      { state: 'Punjab',            country: 'India' },
  'jalandhar':     { state: 'Punjab',            country: 'India' },
  'patiala':       { state: 'Punjab',            country: 'India' },

  // ── Madhya Pradesh ──
  'bhopal':        { state: 'Madhya Pradesh',    country: 'India' },
  'indore':        { state: 'Madhya Pradesh',    country: 'India' },
  'gwalior':       { state: 'Madhya Pradesh',    country: 'India' },
  'jabalpur':      { state: 'Madhya Pradesh',    country: 'India' },
  'ujjain':        { state: 'Madhya Pradesh',    country: 'India' },

  // ── Bihar ──
  'patna':         { state: 'Bihar',             country: 'India' },
  'gaya':          { state: 'Bihar',             country: 'India' },
  'muzaffarpur':   { state: 'Bihar',             country: 'India' },

  // ── Odisha ──
  'bhubaneswar':   { state: 'Odisha',            country: 'India' },
  'cuttack':       { state: 'Odisha',            country: 'India' },

  // ── Assam ──
  'guwahati':      { state: 'Assam',             country: 'India' },
  'dibrugarh':     { state: 'Assam',             country: 'India' },

  // ── Kerala ──
  'kochi':         { state: 'Kerala',            country: 'India' },
  'cochin':        { state: 'Kerala',            country: 'India' },
  'thiruvananthapuram': { state: 'Kerala',       country: 'India' },
  'trivandrum':    { state: 'Kerala',            country: 'India' },
  'kozhikode':     { state: 'Kerala',            country: 'India' },
  'calicut':       { state: 'Kerala',            country: 'India' },
  'thrissur':      { state: 'Kerala',            country: 'India' },

  // ── Haryana ──
  'panipat':       { state: 'Haryana',           country: 'India' },
  'rohtak':        { state: 'Haryana',           country: 'India' },
  'karnal':        { state: 'Haryana',           country: 'India' },
  'hisar':         { state: 'Haryana',           country: 'India' },

  // ── Jharkhand ──
  'ranchi':        { state: 'Jharkhand',         country: 'India' },
  'jamshedpur':    { state: 'Jharkhand',         country: 'India' },
  'dhanbad':       { state: 'Jharkhand',         country: 'India' },

  // ── Uttarakhand ──
  'dehradun':      { state: 'Uttarakhand',       country: 'India' },
  'haridwar':      { state: 'Uttarakhand',       country: 'India' },
  'rishikesh':     { state: 'Uttarakhand',       country: 'India' },

  // ── Himachal Pradesh ──
  'shimla':        { state: 'Himachal Pradesh',  country: 'India' },
  'manali':        { state: 'Himachal Pradesh',  country: 'India' },
  'dharamshala':   { state: 'Himachal Pradesh',  country: 'India' },

  // ── Goa ──
  'goa':           { state: 'Goa',               country: 'India' },
  'panaji':        { state: 'Goa',               country: 'India' },
  'margao':        { state: 'Goa',               country: 'India' },

  // ── Chhattisgarh ──
  'raipur':        { state: 'Chhattisgarh',      country: 'India' },

  // ── Jammu & Kashmir ──
  'srinagar':      { state: 'Jammu & Kashmir',   country: 'India' },
  'jammu':         { state: 'Jammu & Kashmir',   country: 'India' },

  // ── International — USA ──
  'new york':      { state: 'New York',          country: 'USA' },
  'los angeles':   { state: 'California',        country: 'USA' },
  'san francisco': { state: 'California',        country: 'USA' },
  'chicago':       { state: 'Illinois',          country: 'USA' },
  'houston':       { state: 'Texas',             country: 'USA' },
  'miami':         { state: 'Florida',           country: 'USA' },
  'seattle':       { state: 'Washington',        country: 'USA' },
  'boston':        { state: 'Massachusetts',     country: 'USA' },
  'dallas':        { state: 'Texas',             country: 'USA' },
  'austin':        { state: 'Texas',             country: 'USA' },

  // ── International — UK ──
  'london':        { state: 'England',           country: 'UK' },
  'manchester':    { state: 'England',           country: 'UK' },
  'birmingham':    { state: 'England',           country: 'UK' },
  'glasgow':       { state: 'Scotland',          country: 'UK' },

  // ── International — UAE ──
  'dubai':         { state: 'Dubai',             country: 'UAE' },
  'abu dhabi':     { state: 'Abu Dhabi',         country: 'UAE' },
  'sharjah':       { state: 'Sharjah',           country: 'UAE' },

  // ── International — Singapore / Australia / Canada ──
  'singapore':     { state: '',                  country: 'Singapore' },
  'sydney':        { state: 'New South Wales',   country: 'Australia' },
  'melbourne':     { state: 'Victoria',          country: 'Australia' },
  'toronto':       { state: 'Ontario',           country: 'Canada' },
  'vancouver':     { state: 'British Columbia',  country: 'Canada' },
};

/**
 * lookupCity(cityName) → { state, country } | null
 * Case-insensitive, trims whitespace
 */
export function lookupCity(cityName) {
  if (!cityName) return null;
  return CITY_LOOKUP[cityName.toLowerCase().trim()] || null;
}

/**
 * deriveFromCities(csvString) → { state, country }
 *
 * Given a comma-separated city string (multi-value field):
 * - If all cities map to same state   → use that state, else ''
 * - If all cities map to same country → use that country, else ''
 * - Unrecognised cities are ignored for derivation
 */
export function deriveFromCities(csvString) {
  if (!csvString) return { state: '', country: '' };

  const cities  = csvString.split(',').map(s => s.trim()).filter(Boolean);
  const results = cities.map(c => lookupCity(c)).filter(Boolean);

  if (results.length === 0) return { state: '', country: '' };

  const states    = [...new Set(results.map(r => r.state))];
  const countries = [...new Set(results.map(r => r.country))];

  return {
    state:   states.length   === 1 ? states[0]   : '',
    country: countries.length === 1 ? countries[0] : '',
  };
}
